module.exports = __webpack_public_path__ + "static/media/rabbit.a2fa623b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rabbit.png
// module id = 559
// module chunks = 27